import React from 'react';

import RoleList from './RoleList';

import classes from './RolesPage.module.css';


const TableContainer = ({
    roleAction,
    setRoleAction,
    setSelectedRole,
    ...props
}) => {

    return (
        <div className={classes.TableContainer}>
            <div className={classes.GridContainer}>
                <RoleList
                    roleAction={roleAction}
                    setRoleAction={setRoleAction}
                    setSelectedRole={setSelectedRole}
                />
            </div>
        </div>
    );
};

export default TableContainer;
